// extracted by mini-css-extract-plugin
module.exports = {"maindiv":"LegalInfo_maindiv__2ZKL8","content_div":"LegalInfo_content_div__1rHxK","markdown_div":"LegalInfo_markdown_div__1N-WX","loadingdiv":"LegalInfo_loadingdiv__Lh76E"};